export const SET_SELECTED_LANGUAGE = 'setSelectedLanguage';
export const SET_LANGUAGES_LIST = 'setLanguagesList';
export const LIST_LOADING = 'listLoading';
export const LIST_LOADED = 'listLoaded';
